module.exports = __webpack_public_path__ + "assets/ba3d8d5a5f6fa2f7e021ab089f78b62e.png";